export default __webpack_public_path__ + "static/media/family-autumn-park-coronavirus-theme-mother-with-daughter (1).33e93afb.jpg";